import { jsx as n } from "react/jsx-runtime";
import { useAlertStyles as l } from "@chakra-ui/react";
import { CircleInfoIcon as s, TriangleExclamationIcon as t, CircleCheckIcon as i, CircleExclamationIcon as a } from "../../icons/componentIcons.mjs";
const f = ({ status: e, ...o }) => {
  const r = l(), c = "solid";
  switch (e) {
    case "error":
      return /* @__PURE__ */ n(a, { variant: c, sx: r.icon, color: "red.500", ...o });
    case "success":
      return /* @__PURE__ */ n(i, { variant: c, sx: r.icon, color: "green.500", ...o });
    case "warning":
      return /* @__PURE__ */ n(t, { variant: c, sx: r.icon, color: "orange.500", ...o });
    case "info":
      return /* @__PURE__ */ n(s, { variant: c, sx: r.icon, color: "blue.500", ...o });
    default:
      return null;
  }
};
export {
  f as default
};
